import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Login from './login';
import NotFound from './notFound';
import Plan from './plan';
import SignUp from './signUp';
import Payment from './payment';
import Invoice from './invoice';
import MyAccount from './myAccount';
import MySubscriptions from './mySubscriptions';
import MySubscription from './mySubscription';
import BillingActivity from './billingActivity';
import CreateVirtualSpace from './createVirtualSpace';
import MyVirtualSpaces from './myVirtualSpaces';
import ChangeSubscription from './changeSubscription';

import ForgotPassword from './forgotPassword';
import ResetPassword from './resetPassword';

import Layout from '../../utils/components/layout';

const User = () => {

  return (
    <Layout>
      <Routes>
        <Route exact path="/plan/:planId" element={<Plan />} />
        <Route exact path="/signUp" element={<SignUp />} />
        <Route exact path="/payment" element={<Payment />} />
        <Route exact path="/invoice" element={<Invoice />} />
        <Route exact path="/createVirtualSpace/:subscriptionId" element={<CreateVirtualSpace />} />
        <Route exact path="/myVirtualSpaces" element={<MyVirtualSpaces />} />
        <Route exact path="/myAccount" element={<MyAccount />} />
        <Route exact path="/mySubscriptions" element={<MySubscriptions />} />
        <Route exact path="/mySubscription/:subscriptionId" element={<MySubscription />} />
        <Route exact path="/changeSubscription/:subscriptionId" element={<ChangeSubscription />} />
        <Route exact path="/billingActivity" element={<BillingActivity />} />
        <Route path="/" element={<Login />} />
        <Route exact path="/reset-password" element={<ResetPassword/>} />
        <Route exact path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace/>} />
      </Routes>
    </Layout>
  );
}

export default User;